import React from "react";
import shallowequal from "shallowequal";
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import {renderPrintFooter} from '../../utils';
import {TEXAS_MARKET_TRANSACTIONS} from '../../consts/queries';
import MarketReport from "../MarketReport";
import { reportTypes } from "../../consts/consts";
import { fetchData } from "../Service/graphQlService";
import { GET_TEXAS_MARKET_TRANSACTIONS } from "../Graphql/Queries/propertiesQuery";

export default class MarketTransactionBreakdown extends MarketReport {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`});
        this.fetch(this.props.location.query);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
        window.history.replaceState(null, '');
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    fetch(q) {
        const query = {...q};
        const queryPrevYear = {...q};

        const baseDate = query.base_max ? new Date(query.base_max) : query.base_min ? new Date(query.base_min) : new Date();
        const baseMonth = baseDate.getMonth()+1;
        const baseDay = baseDate.getDate();
        let year = baseDate.getFullYear().toString(), prevYear = year - 1;

        if (query.comparison_min || query.comparison_max) {
            delete query.comparison_min;
            delete query.comparison_max;
            delete queryPrevYear.base_min;
            delete queryPrevYear.base_max;
        }
        else if (query.base_min || query.base_max) {
            delete queryPrevYear.base_min;
            delete queryPrevYear.base_max;
            queryPrevYear.comparison_min =`01/01/${prevYear}`;
            queryPrevYear.comparison_max =`${baseMonth}/${baseDay}/${prevYear}`;
        }
        else {
            query.base_min = `01/01/${year}`;
            query.base_max = `12/31/${year}`;
            queryPrevYear.comparison_min =`01/01/${prevYear}`;
            queryPrevYear.comparison_max =`12/31/${prevYear}`;
        }

        const optionsSTNL = filter({...query, type: 'STNL'}, 'market-transaction-breakdown');
        const optionsPrevYearSTNL = filter({...queryPrevYear, type: 'STNL'}, 'market-transaction-breakdown');
        const optionsMT = filter({...query, type: 'MT'}, 'market-transaction-breakdown');
        const optionsPrevYearMT = filter({...queryPrevYear, type: 'MT'}, 'market-transaction-breakdown');

        const requests = [
            fetchData(GET_TEXAS_MARKET_TRANSACTIONS, { options: optionsSTNL.param}),
            fetchData(GET_TEXAS_MARKET_TRANSACTIONS, { options: optionsPrevYearSTNL.param}),
            fetchData(GET_TEXAS_MARKET_TRANSACTIONS, { options: optionsMT.param}),
            fetchData(GET_TEXAS_MARKET_TRANSACTIONS, { options: optionsPrevYearMT.param}),
        ];

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data && res[0].data.getTexasMarketTransactions &&
                res[1] && res[1].data && res[1].data.getTexasMarketTransactions &&
                res[2] && res[2].data && res[2].data.getTexasMarketTransactions &&
                res[3] && res[3].data && res[3].data.getTexasMarketTransactions) {

                const transactions = [];
                transactions.STNL = MarketTransactionBreakdown.buildTableData({data: res[0].data.getTexasMarketTransactions, prevData: res[1].data.getTexasMarketTransactions, type: 'STNL'});
                transactions.MT = MarketTransactionBreakdown.buildTableData({data: res[2].data.getTexasMarketTransactions, prevData: res[3].data.getTexasMarketTransactions, type: 'MT'});

                this.setState({
                    query,
                    year: year,
                    previousYear: prevYear,
                    transactions
                });
                return;
            }

            this.setState({
                query,
                year: year,
                previousYear: prevYear
            });
        });
    }

    render() {
        const {query, transactions, year, previousYear, isPrint, printBackground} = this.state;
        const reportType = reportTypes.MarketTransactionBreakdown;

        return (
            <div className='MarketReport'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.MT, type: 'Multi-Tenant', market: query.MARKET, year, previousYear, baseMin: query.BASE_MIN, baseMax: query.BASE_MAX})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.STNL, type: 'Single-Tenant', market: query.MARKET, year, previousYear, baseMin: query.BASE_MIN, baseMax: query.BASE_MAX})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
}